import { interfaces } from 'inversify';
import { useInjection } from 'inversify-react';

export type AsyncHookResult<R = unknown, E = unknown> = {
  result?: R;
  inProgress: boolean;
  error?: E;
};
export type InjectableHook<T extends object> = () => T;

export function useHookInjection<T extends InjectableHook<object>>(
  identifier: interfaces.ServiceIdentifier<T>,
): ReturnType<T> {
  return useInjection<T>(identifier)() as ReturnType<T>;
}
